import { SelectOption } from '../../types';

interface Props {
  className?: string;
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
}
export default function GoodsTypeTabBar({ className, options, value, onChange }: Props) {
  return (
    <div className={`goodstab-bar-block ${className}`}>
      {options.map((i) => (
        <div
          key={i.value}
          className={`tab-bar-item ${i.value === value ? 'active' : ''}`}
          onClick={() => onChange(i.value.toString())}
        >
          <div className="label font-size-14">{i.label}</div>
          <div className="active-line" />
        </div>
      ))}
    </div>
  );
}
